import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';
import MuiLink from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface Props {
  readonly to: string;
  // Opens the page in a new tab, not to leave the current one (a form, ...).
  readonly inNewTab?: boolean;
}

export const ConsultButton = ({ to, inNewTab = false }: Readonly<Props>) =>
  inNewTab ? (
    <Button
      component={MuiLink}
      endIcon={<OpenInNewIcon />}
      href={to}
      rel="noopener noreferrer"
      size="medium"
      target="_blank"
      variant="outlined"
    >
      Consulter
    </Button>
  ) : (
    <Button component={Link} size="medium" to={to} variant="outlined">
      Consulter
    </Button>
  );
